import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon10: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 16.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 16" width={width} height={height} {...props}>
      <Path
        d="M20 13.5C20 14.88 18.88 16 17.5 16C16.683 16 15.957 15.607 15.501 15.001L4.49799 15L4.423 15.097C3.964 15.649 3.273 16 2.5 16C1.12 16 0 14.88 0 13.5L0.00100708 13.406C7.08003e-06 13.395 0 13.384 0 13.373V8.5L0.00698853 8.35501C0.0629885 7.76501 0.461 7.27599 1 7.08499V2.00299C1 0.896991 1.89699 0 3.00299 0H9.5C13.642 0 17 3.358 17 7.5C17 7.519 16.999 7.53801 16.997 7.55701L17.58 7.715C18.421 7.957 19.001 8.72699 19.001 9.60199V11.501C19.607 11.957 20 12.683 20 13.5ZM17.5 12C16.672 12 16 12.672 16 13.5C16 14.328 16.672 15 17.5 15C18.328 15 19 14.328 19 13.5C19 12.672 18.328 12 17.5 12ZM2.5 12C1.672 12 1 12.672 1 13.5C1 14.328 1.672 15 2.5 15C3.328 15 4 14.328 4 13.5C4 12.672 3.328 12 2.5 12ZM6.99899 1H3.00299C2.44899 1 2 1.44899 2 2.00299V7.5C2 7.776 1.776 8 1.5 8C1.223 8 1 8.223 1 8.5V11.5C1.418 11.186 1.937 11 2.5 11C3.88 11 5 12.12 5 13.5C5 13.671 4.98301 13.839 4.95001 14H15.05C15.017 13.839 15 13.671 15 13.5C15 12.12 16.12 11 17.5 11C17.671 11 17.839 11.017 18 11.05L18.001 9.60199C18.001 9.17299 17.716 8.79501 17.31 8.67801L9.23001 6.48801C7.91401 6.13001 7 4.93501 7 3.57101L6.99899 1ZM9.5 1H8V3.57101C8 4.48401 8.611 5.283 9.492 5.522L15.997 7.28601C15.883 3.79501 13.018 1 9.5 1Z"
        fill="#F3123C"
      />
    </Icon>
  )
}
